import React from 'react';
import Refresh from '../../icons/refresh.svg';

interface LoadingSpinnerAttributes {
  className?: string;
}

const LoadingSpinner = (props: LoadingSpinnerAttributes) => {
  const { className = '' } = props;
  return (
    <Refresh
      className={`icon spin ${className}`}
      style={{ fill: 'currentColor' }}
    />
  );
};

export default LoadingSpinner;
